@if(!destroying){
<div @cursorAnimation class="cb-user-cursor" [class.cb-preview]="isPreview()"
    [class.cb-fixed]="x()!==undefined && y()!==undefined" [style.left.%]="x()" [style.top.%]="y()"
    [style.color]="currentColor()">
    <div class="cb-user-cursor-arrow">
        <svg width="60" height="68" viewBox="0 0 60 68" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_9644_7764)">
                <path d="M44.5429 31.2L13 12L19.8571 49.0286L28.0857 35.3143L44.5429 31.2Z" fill="currentColor" />
                <path
                    d="M13.7131 10.8285L11.093 9.23369L11.6515 12.2497L18.5086 49.2783L19.1686 52.8418L21.0331 49.7342L28.9694 36.507L44.8755 32.5305L48.0588 31.7346L45.2559 30.0285L13.7131 10.8285Z"
                    stroke="white" stroke-width="2.74286" />
            </g>
            <defs>
                <filter id="filter0_d_9644_7764" x="0.957403" y="0.981632" width="58.846" height="66.6448"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset dy="2.74286" />
                    <feGaussianBlur stdDeviation="4.11429" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9644_7764" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9644_7764" result="shape" />
                </filter>
            </defs>
        </svg>

    </div>
    @if(username.length > 0){
    <div class="cb-user-cursor-name">
        <p>{{username()}}</p>
    </div>
    }
</div>
}